import {useContext, useEffect, useState} from "react";
import {AdviceQuery} from "../queries/AdviceQuery";
import {AdviceListContext} from "../state/adviceContext";
import {useParams} from "react-router-dom";

const useAdviceSameCategoryList = () => {
    const  {state, dispatch} = useContext(AdviceListContext);
    const [isLoading, setIsLoading] = useState(false);
    const {id, categoryId} = useParams();

    useEffect( () => {
        setIsLoading(true)
        Promise.all([AdviceQuery.findByCategory(id, categoryId)]).then( advices => {
            console.log(advices.flat(Infinity));
            dispatch({action: 'initAdvices', payload: advices.flat(Infinity)})
            setIsLoading(false)
        } ).catch(() => setIsLoading(false))
    }, [])

    const adviceOnly = () => {

        return state.filter( advice => advice.variant === 'advice' )
    }

    const findById = (id, variant) => {

        return state.filter(service => service.id === id && service.variant === variant)[0] ?? undefined
    }

    return {isLoading, adviceOnly, advices: state, findById}
}

export {useAdviceSameCategoryList}